// removed by extract-text-webpack-plugin
module.exports = {"profile":"_1zwO0","img":"_3P6Rg","firstName":"_3p2gJ","name":"_1BNWB","outerBar":"_3w6N4","innerBarDem":"_2rPds","innerBarRep":"_1Ims2"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Profile.scss
 ** module id = 107
 ** module chunks = 0
 **/